import { baseApi } from '../../../core/baseApi';
import { unwrapApiResponse } from '../../../patterns/crud';

// Response types
export interface GenerateAgencyZoomKeyResponse {
  message: string;
}

export interface AgencyZoomKeyStatusResponse {
  hasCredentials: boolean;
  isActive: boolean;
}

export interface RevokeAgencyZoomKeyResponse {
  message: string;
}

export interface SaveZapierCredentialsArgs {
  zapKey: string;
  zapSecret: string;
}

export interface ZapierCredentialsResponse {
  zapKey: string | null;
  zapSecret: string | null;
}

export const agencyZoomApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    generateAgencyZoomKey: builder.mutation<GenerateAgencyZoomKeyResponse, void>({
      query: () => ({
        url: '/integrations/agency-zoom/credentials/generate',
        method: 'POST',
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: ['IntegrationsStatus'],
    }),

    getAgencyZoomKeyStatus: builder.query<AgencyZoomKeyStatusResponse, void>({
      query: () => '/integrations/agency-zoom/credentials/status',
      transformResponse: unwrapApiResponse,
      providesTags: ['IntegrationsStatus'],
    }),

    revokeAgencyZoomKey: builder.mutation<RevokeAgencyZoomKeyResponse, void>({
      query: () => ({
        url: '/integrations/agency-zoom/credentials',
        method: 'DELETE',
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: ['IntegrationsStatus'],
    }),

    saveAgencyZoomZapierCredentials: builder.mutation<{ message: string }, SaveZapierCredentialsArgs>({
      query: (body) => ({
        url: '/integrations/agency-zoom/credentials/zapier',
        method: 'PUT',
        body,
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: ['IntegrationsStatus'],
    }),

    getAgencyZoomZapierCredentials: builder.query<ZapierCredentialsResponse, void>({
      query: () => '/integrations/agency-zoom/credentials/zapier',
      transformResponse: unwrapApiResponse,
      providesTags: ['IntegrationsStatus'],
    }),
  }),
});

export const {
  useGenerateAgencyZoomKeyMutation,
  useGetAgencyZoomKeyStatusQuery,
  useRevokeAgencyZoomKeyMutation,
  useSaveAgencyZoomZapierCredentialsMutation,
  useGetAgencyZoomZapierCredentialsQuery,
} = agencyZoomApi;
